class BESSAppProjectEnergyDetailsEditorManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
        if ('gasSupply' in editor.input) {
            this.gasSupplyManager = new BESSAppProjectEnergyDetailsGasSupplyEditorManager(editor);
        }
    }
}